module.exports = __webpack_public_path__ + "static/media/search_white.5cba5eaa.png";